import { SUPPLIER_REGISTER } from 'actionTypes';
import thunkFactory from 'source/utils/redux/baseEntitiesFactory/thunk';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';

// ACTIONS
const rawActions = actionsFactory(SUPPLIER_REGISTER);
const actions = { ...rawActions, ...thunkFactory(SUPPLIER_REGISTER, '/supplier_registers/') };
export { actions };

// REDUCER
const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};


const options = {
  flattenFields: {
    raw_material_id: ['name'],
    supplier_id: ['name', 'id']
  }
};

export default reducerFactory(SUPPLIER_REGISTER, initialState, options);

// SAGAS
const sagas = sagasFactory(SUPPLIER_REGISTER, '/supplier_registers/', { scopedByAccount: true });
export { sagas };
